module.exports = __webpack_public_path__ + "static/doctor_portrait-593df549b2173a80a97e6e07c36151e5.png";